module.exports = __webpack_public_path__ + "img/4.774abe15.png";